
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"38.421","height":"33.427"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 727","fill":"none"}},[_c('path',{attrs:{"data-name":"Path 6781","d":"M15.1 25.263v7.6h-4.262V14.911h8.372"}}),_c('path',{attrs:{"data-name":"Path 6782","d":"M19.211 20.042c0 1.314-4.11 2.278-4.11 5.221"}}),_c('path',{attrs:{"data-name":"Path 6783","d":"M19.21 14.911h8.371v17.945h-4.262v-7.595c0-2.943-4.11-3.907-4.11-5.221"}}),_c('path',{attrs:{"data-name":"Path 6784","d":"M35.466 32.858l.081-3.25c0-2.01-2.888-2.88-2.888-3.777 0 .9-2.726 1.768-2.726 3.777l-.081 3.25"}}),_c('path',{attrs:{"data-name":"Path 6785","d":"M27.581 32.858h10.283V21.802H27.581"}}),_c('path',{attrs:{"data-name":"Line 25","d":"M37.865 24.296H27.582"}}),_c('path',{attrs:{"data-name":"Path 6786","d":"M2.955 32.858l-.081-3.25c0-2.01 2.888-2.88 2.888-3.777 0 .9 2.726 1.768 2.726 3.777l.081 3.25"}}),_c('path',{attrs:{"data-name":"Path 6787","d":"M10.839 32.858H.552V21.802h10.283"}}),_c('path',{attrs:{"data-name":"Line 26","d":"M.555 24.296h10.283"}}),_c('path',{attrs:{"data-name":"Line 27","d":"M10.839 18.048h16.743"}}),_c('path',{attrs:{"data-name":"Path 6788","d":"M20.441 10.121h-2.465l-.688 4.792h3.836z"}}),_c('path',{attrs:{"data-name":"Path 6789","d":"M20.441 10.121h-2.465l-.688-2.292h3.836z"}}),_c('path',{attrs:{"data-name":"Path 6790","d":"M20.441 5.995h-2.465l-.688 1.834h3.836z"}}),_c('path',{attrs:{"data-name":"Line 28","d":"M19.21 5.995V.556"}}),_c('path',{attrs:{"data-name":"Path 6791","d":"M10.838 16.135H7.191a12.019 12.019 0 0124.038 0h-3.648"}}),_c('path',{attrs:{"data-name":"Line 29","d":"M7.191 16.135v5.531"}}),_c('path',{attrs:{"data-name":"Line 30","d":"M31.229 16.135v5.668"}})])])
          )
        }
      }
    